import { Flex, Spinner } from '@cad-arc';
import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '~/api-client';
import { HospitalsResource } from '@mark43/cad-api';
import { MenuLoadingError } from '../common/components/menu-loading-error';
import { ErrorBoundary } from '../monitoring/error-boundary';
import { HospitalQueueRowData } from '../socket/stream-types';
import { EditHospitalItem } from './edit-hosptial-item';
import { HospitalStatusSubmenu } from './hospital-status-submenu';
import { ViewHospitalOnMapItem } from './view-hospital-on-map-item';

export function HospitalContextMenu({ data }: { data: HospitalQueueRowData }): React.ReactElement {
    const apiClient = useApiClient();

    const { data: hospitalContextMenuView, isInitialLoading, isError } = useQuery(
        ['hospitalContextMenuView', data.id],
        () => {
            return apiClient
                .request<HospitalsResource.GetHospitalContextMenu>({
                    method: 'POST',
                    url: `hospitals/context_menu/`,
                    data: { hospitalId: data.id },
                })
                .then((response) => {
                    return response.data.data;
                });
        }
    );

    if (isInitialLoading) {
        return (
            <Flex justifyContent="center" alignItems="center" w="100%" h="100%">
                <Spinner />
            </Flex>
        );
    }

    if (isError) {
        return <MenuLoadingError />;
    }

    if (!hospitalContextMenuView) {
        return <div />;
    }

    const {
        editHospitalContextMenuItemView,
        hospitalStatusContextMenuItemView,
        viewOnMapContextMenuItemView,
    } = hospitalContextMenuView;

    const { id: hospitalId } = data;

    return (
        <ErrorBoundary
            name="HOSPITAL_CONTEXT_MENU"
            messageVerbNoun="Opening the hospital menu"
            asToast={true}
        >
            <HospitalStatusSubmenu
                hospitalId={data.id}
                hospitalStatusContextMenuItemView={hospitalStatusContextMenuItemView}
            />
            <EditHospitalItem
                hospitalId={data.id}
                editHospitalContextMenuItemView={editHospitalContextMenuItemView}
            />
            <ViewHospitalOnMapItem
                viewOnMapContextMenuItemView={viewOnMapContextMenuItemView}
                hospitalId={hospitalId}
            />
        </ErrorBoundary>
    );
}
